module.exports = __webpack_public_path__ + "img/fc-dynamo-rest.db802e3b.png";